import React, {PropTypes} from 'react';
import classNames from 'classnames';
import FieldValidationError from './FieldValidationError.jsx';
import Select from 'react-select';
import moment from 'moment';

const TimeField = ({
  disabled,
  increment,
  input,
  label,
  matchPos,
  meta: {touched, error},
  name,
  placeholder,
  searchable,
  simpleValue,
  style
}) => (
  <div className={classNames(
    'form-group',
    {'has-error': touched && error}
  )}>
    {
      label || placeholder
      ? <label htmlFor={name}>{label || placeholder}</label>
      : null
    }
    <Select {...input}
      disabled={disabled}
      options={getTimeOptions(increment)}
      placeholder={placeholder}
      searchable={searchable}
      matchPos={matchPos}
      simpleValue={simpleValue}
      style={style}
      onBlur={() => input.onBlur(input.value)}
    />
    <FieldValidationError
      touched={touched}
      error={error}
    />
  </div>
);

const getTimeOptions = increment => {
  let options = [];
  const todaysDate = moment().format('YYYY-MM-DD'),
    nextDay = moment(todaysDate).add(1, 'day');

  for(let m = moment(todaysDate); m.diff(nextDay, 'minutes') < 0; m.add(increment, 'minutes')) {
    options.push({ value: m.format('HH:mm'), label: m.format('hh:mm A')});
  }

  return options;
};

TimeField.propTypes = {
  disabled: PropTypes.bool,
  increment: PropTypes.number,
  input: PropTypes.object,
  label: PropTypes.node,
  matchPos: PropTypes.string,
  meta: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  searchable: PropTypes.bool,
  simpleValue: PropTypes.bool,
  style: PropTypes.object
};

TimeField.defaultProps = {
  disabled: false,
  increment: 15,
  input: {},
  label: null,
  matchPos: 'start',
  meta: {},
  name: '',
  placeholder: '',
  searchable: true,
  simpleValue: true,
  style: {}
};

export default TimeField;



// WEBPACK FOOTER //
// ./src/features/shared/TimeField.jsx